import { render, staticRenderFns } from "./WatchGame.vue?vue&type=template&id=8c73f248&scoped=true&"
import script from "./WatchGame.vue?vue&type=script&lang=js&"
export * from "./WatchGame.vue?vue&type=script&lang=js&"
import style0 from "./WatchGame.vue?vue&type=style&index=0&id=8c73f248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c73f248",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
